import React, { useEffect, useState, useContext } from "react";

import { Card, CardHeader } from "@mui/material";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import AccountingApi from "../../../Classes/API/AccountingApi";
import Swal from "sweetalert2";
import CreateContractReq from "../../../Classes/Models/Requests/Accounting/CreateContractReq";
import { LanguageContext } from "App";
import { useNavigate } from "react-router-dom";
import { TramSharp } from "@mui/icons-material";

const index = () => {
  const navigate = useNavigate();
  const { translations } = useContext(LanguageContext);

  const [Name, setName] = useState("");
  const [Description, setDescription] = useState("");
  const [IsSplitSessions, setIsSplitSessions] = useState(false);

  const onCreateClick = async () => {
    let req = new CreateContractReq();

    req.Name = Name;
    req.Description = Description;
    // req.Discount = Discount;
    if (!Name || !Description) {
      Swal.fire({
        title: "Error",
        text: "Please enter Contract Name or Description or Both",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    let res = await AccountingApi.CreateContract(req);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: res.message,
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        navigate("/Contracts/Details", { state: { SearchContract: res.data } });
      });
    } else {
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <Card sx={{ padding: "2em" }}>
        <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
          <MDTypography variant="h6" fontWeight="medium">
            {translations.sidebarChildernAccountingCreateContract}
          </MDTypography>
          <div>
            <MDButton
              type="button"
              sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
              color="text"
              onClick={() => onCreateClick()}
            >
              + {translations.CreateDomesticStayCreate}
            </MDButton>
          </div>
        </MDBox>

        <div className={translations.setlang === "ar" ? "rtl-label" : ""}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-4 mt-3">
                <MDInput
                  sx={{ width: "100%" }}
                  label={translations.CreateContractContractName}
                  onChange={(e) => setName(e.target.value)}
                  type={"text"}
                  fullWidth
                ></MDInput>
              </div>

              <div className="col-md-4 mt-3">
                <MDInput
                  sx={{ width: "100%" }}
                  label={translations.CreateContractDescription}
                  onChange={(e) => setDescription(e.target.value)}
                  type={"text"}
                  fullWidth
                ></MDInput>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </DashboardLayout>
  );
};

export default index;
